/**
 * en-GB messages added by Phase 4 task S45 (docs/PHASE-4-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const s45EnGB = {
    'email.pre-registration.wallet.button': 'Add to Google Wallet',
    'outlook.skip.internal': 'Skipped: this person works here, so they do not need to be pre-registered.',
    'dp.pre-registration.preregistrations': 'Pre-registrations',
    'dp.pre-registration.answers': 'Answers given in advance',
    'dp.pre-registration.progress': 'Pre-arrival progress',
};
//# sourceMappingURL=s45.js.map